module.exports = __webpack_public_path__ + "img/inactive-1.663656e9.svg";